// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"00242833","833":"e200228b"}[chunkId] + ".chunk.js";
};